import { zh } from './locales/zh';
import { en } from './locales/en';
import { jp } from './locales/jp';

// 语言类型定义
export type Language = 'zh' | 'en' | 'jp';

// 语言包类型定义
type Locale = typeof zh;

// 语言包映射
const locales: Record<Language, Locale> = {
  zh,
  en,
  jp
};

// 国际化服务类
export class I18nService {
  private static instance: I18nService;
  private currentLanguage: Language = 'zh';
  private listeners: Set<() => void> = new Set();

  private constructor() {
    // 从本地存储读取语言设置
    const savedLang = localStorage.getItem('language') as Language;
    if (savedLang && locales[savedLang]) {
      this.currentLanguage = savedLang;
    }
  }

  // 获取单例实例
  public static getInstance(): I18nService {
    if (!I18nService.instance) {
      I18nService.instance = new I18nService();
    }
    return I18nService.instance;
  }

  // 获取当前语言
  public getLanguage(): Language {
    return this.currentLanguage;
  }

  // 设置语言
  public setLanguage(lang: Language): void {
    if (locales[lang] && lang !== this.currentLanguage) {
      this.currentLanguage = lang;
      localStorage.setItem('language', lang);
      this.notifyListeners();
    }
  }

  // 翻译函数
  public t(key: keyof Locale): string {
    return locales[this.currentLanguage][key] || key;
  }

  // 添加语言变化监听器
  public addListener(listener: () => void): void {
    this.listeners.add(listener);
  }

  // 移除语言变化监听器
  public removeListener(listener: () => void): void {
    this.listeners.delete(listener);
  }

  // 通知所有监听器
  private notifyListeners(): void {
    this.listeners.forEach(listener => listener());
  }
}

// 导出国际化服务实例
export const i18nService = I18nService.getInstance();

// 导出翻译函数的便捷方法
export const t = (key: keyof Locale): string => i18nService.t(key);
